// PoroAppi Azure Environment Configuration

export const environment = {
  production: false,
  appFlavor: 'poroappi',

  api: {
    baseUrl: 'https://testbed.ymparisto.fi(Open311maintenance',
    extension: true,
    apimSubscriptionKey: '9202068587b74fc3908a7a933b6dbe35'
  },

  azure: {
    // PoroAppi-specific Azure AD B2C configuration
    clientId: 'POROAPPI-CLIENT-ID', // TODO: Replace with actual client ID
    authority: 'https://sykecitobs.b2clogin.com/sykecitobs.onmicrosoft.com/B2C_1_SignUpSignIn',
    knownAuthorities: ['sykecitobs.b2clogin.com'],
    redirectUri: window.location.origin,
    postLogoutRedirectUri: window.location.origin,

    // Storage configuration
    storageUrl: 'https://sykecitobsstorage.blob.core.windows.net',
    containerName: 'poroappi-uploads',
    sasToken: '', // Not needed - backend handles storage

    // API Scopes
    apiScopes: [],

    // Image upload API URL (same as api.baseUrl, backend appends /images)
    imageApiUrl: 'https://testbed.ymparisto.fi(Open311maintenance'
  },

  useAzureStorage: true,
  useAzureAuth: true,

  // Disabled Firebase config (kept for reference/rollback)
  firebaseConfig: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: ""
  }
};